import { B4Regular, px2rem, Spacer } from "@moim/common";
import {
  Svg48EmptyBadge,
  Svg48EmptyNft,
  Svg48EmptyPosition,
  Svg48EmptyToken,
} from "@moim/icons";
import styled from "styled-components";
import React from "react";
import { FormattedMessage } from "react-intl";

const Wrapper = styled.div`
  width: 100%;
  padding: ${px2rem(16)} ${px2rem(16)} ${px2rem(14)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Text = styled(B4Regular)`
  width: 100%;
  color: ${props => props.theme.colorV2.colorSet.grey300};
  text-align: center;
`;

const EmptyBase: React.FC<{
  icon: React.ReactNode;
  text: string;
}> = React.memo(({ icon, text }) => {
  return (
    <Wrapper>
      {icon}
      <Spacer value={8} />
      <Text>
        <FormattedMessage id={text} />
      </Text>
    </Wrapper>
  );
});

const EmptyPositionIcon = styled(Svg48EmptyPosition).attrs(props => ({
  size: "l",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey50,
}))``;

export const PositionEmpty = React.memo(() => {
  return (
    <EmptyBase
      icon={<EmptyPositionIcon />}
      text="profile_show_position_empty"
    />
  );
});

const EmptyNFTIcon = styled(Svg48EmptyNft).attrs(props => ({
  size: "l",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey50,
}))``;

export const NFTEmpty = React.memo(() => {
  return <EmptyBase icon={<EmptyNFTIcon />} text="profile_show_nft_empty" />;
});

const EmptyBadgeIcon = styled(Svg48EmptyBadge).attrs(props => ({
  size: "l",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey50,
}))``;

export const BadgeEmpty = React.memo(() => {
  return (
    <EmptyBase icon={<EmptyBadgeIcon />} text="profile_show_badge_empty" />
  );
});

const EmptyTokenIcon = styled(Svg48EmptyToken).attrs(props => ({
  size: "l",
  touch: 42,
  iconColor: props.theme.colorV2.colorSet.grey50,
}))``;

export const TokenEmpty = React.memo(() => {
  return (
    <EmptyBase icon={<EmptyTokenIcon />} text="profile_show_token_empty" />
  );
});
